import { render, staticRenderFns } from "./ProducersList.vue?vue&type=template&id=30e31e6c&scoped=true&"
import script from "./ProducersList.vue?vue&type=script&lang=js&"
export * from "./ProducersList.vue?vue&type=script&lang=js&"
import style0 from "./ProducersList.vue?vue&type=style&index=0&id=30e31e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e31e6c",
  null
  
)

export default component.exports